import {OrgItemType} from '@app/views/admin/application-settings/models/orgItem.model';

enum EduToneTreeNodeType {
    SCHOOL = 'school',
    ENTITY_TYPE = 'entity type',
    GROUP_VALUE = 'group value',
    SECTION_VALUE = 'section value',
    VALUE = 'value'
}

export type OUTreeNodeType = OrgItemType | EduToneTreeNodeType;
export const OUTreeNodeType = {...OrgItemType, ...EduToneTreeNodeType};
export const OUTreeNodeTypeTitle = new Map<OUTreeNodeType, string>([
    [OUTreeNodeType.OU, 'OU'],
    [OUTreeNodeType.GROUP, 'Group']
]);
